export const countdownTime = 1.5; // min
export const delay = 2000; // ms

export default {
    delay,
    countdownTime
};
